export const errorMsgHandler = (errorMsg: string) => {
  if (errorMsg === 'Request failed with status code 429') {
    return 'Tanium Account is unavailable. Please try again later.';
  }
  return errorMsg;
};
